import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionComment/pageContext';

export const PetitionCommentErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for PetitionComment page (error: ${error})`);
};
